import type { HelpFile } from '../../types/help'
import { ConnectorConfigFormTestIds } from '../../../testids/ConnectorConfigFormTestIds'

export const connectorConfigFormHelp: HelpFile = {
  docPage: '/docs/systems/connectors',
  texts: {
    [ConnectorConfigFormTestIds.selectAuthType]: 'Authentifizierungsverfahren, mit dem der Connector mit dem Zielsystem kommuniziert — z. B. Basic Auth, OAuth2 Client Credentials oder API-Key.',
    [ConnectorConfigFormTestIds.clientSecretRef]:
      'Referenz auf das OAuth2-Client-Secret.',
    [ConnectorConfigFormTestIds.passwordSecretRef]:
      'Referenz auf das Passwort-Secret für Basic-Authentifizierung.',
    [ConnectorConfigFormTestIds.tokenSecretRef]:
      'Referenz auf das Bearer-Token-Secret.',
  },
}
